import React from 'react';
import { TooltipKeys } from '../../tooltips/TooltipKeys';
import UINextStep from '../subcomponents/UINextStep';
import UIPreviousStep from '../subcomponents/UIPreviousStep';
import UIVoice from '../subcomponents/UIVoice';
import subComponentTypes from '../subcomponents/types';
import UIEditorComponentRenderer from '../UIEditorComponentRenderer';

export default function TBlank(props)
{
	function getRawProperties()
	{
		return {
			[subComponentTypes.NEXT_STEP]:{ ...UINextStep({ ...props }) },
			[subComponentTypes.PREVIOUS_STEP]:{ ...UIPreviousStep({ ...props }) },
			[subComponentTypes.VOICE]:{ ...UIVoice({ ...props }) }
		}
	}

	function repackProperties()
	{
		let rawProperties = getRawProperties();
		// console.log(rawProperties);
		let flatProperties = [
			{
				...rawProperties.PreviousStep.props.properties.visible,
				key: 'visible',
				subcomponent: rawProperties.PreviousStep.props.subcomponent,
				title: rawProperties.PreviousStep.props.title,
				//className: "uiEditorStepToggle",
			},
			{
				...rawProperties.NextStep.props.properties.visible,
				key: 'visible',
				subcomponent: rawProperties.NextStep.props.subcomponent,
				title: rawProperties.NextStep.props.title,
				//className: "uiEditorStepToggle",
			},
			{
				type: 'group',
				key: 'voice group',
				title: rawProperties.Voice.props.title,
				subcomponent: null,
				tooltip: TooltipKeys.UIVoice,
				children: [
					{
						...rawProperties.Voice.props.properties.Voice,
						key: 'Voice',
						subcomponent: rawProperties.Voice.props.subcomponent,
						title: "",
					}
				]
			},
		]
		return <UIEditorComponentRenderer
			{...props}
			properties={flatProperties}
		/>;
	}

	if(props.getProperties)
	{
		return getRawProperties();
	}

	return (
		props.context === 'editor' ?
			<>
				{repackProperties()}
			</>
			:
			<>
				<UINextStep {...props} />
				<UIPreviousStep {...props} />
				<UIVoice {...props} />
			</>
	);
}